module.exports = __webpack_public_path__ + "static/media/EnvPromo10.e142ef95.jpg";